<template>
  <div>
    <template v-if="!modalOnly">
      <BaseListItemPicker
        :value="value"
        :button-text="$t('components.rolePicker.labels.selectRoles')"
        :clearable="clearable"
        :disabled="disabled"
        :items="roles"
        :label="label"
        :error="error"
        label-cols="2"
        multiple
        @open="modal = true"
        @input="$emit('input', $event)"
      />
    </template>

    <BaseModal
      :is-open="modal || isOpen"
      :title="$t('components.rolePicker.labels.selectRoles')"
      width="800px"
      @close="closeModal"
    >
      <form class="clearfix" @submit.prevent="getRoles(1)">
        <ul class="filter_form clearfix">
          <li class="filter_form__items">
            <label class="filter_form__label">{{ $t('components.rolePicker.filters.name') }}</label>
            <input v-model="params.name" type="text" class="form-control" />
          </li>
          <li class="filter_form__items">
            <label class="filter_form__label">{{ $t('components.rolePicker.filters.code') }}</label>
            <input v-model="params.code" type="text" class="form-control" />
          </li>

          <li class="filter_form__items filter_form__items--full">
            <button
              :disabled="loading"
              type="submit"
              class="btn btn-feat btn-mobile-full pull-right"
            >
              {{ $t('actions.updateResults') }}
            </button>
          </li>
        </ul>
      </form>

      <BaseTable :items="roles" :loading="loading" :pagination="pagination" @update:page="getRoles">
        <template #headers>
          <tr>
            <th></th>
            <th>{{ $t('components.rolePicker.table.headers.name') }}</th>
            <th v-if="publicOnly">
              {{ $t('components.rolePicker.table.headers.description') }}
            </th>
          </tr>
        </template>

        <tr
          v-for="role in roles"
          :class="{
            selected: selectedRoleSet.has(role.code),
          }"
          :key="role.code"
          style="cursor: pointer;"
          @click="toggleRole(role)"
        >
          <td data-label="">
            <input
              :checked="selectedRoleSet.has(role.code)"
              :id="`role-${role.id}`"
              type="checkbox"
            /><label :for="`role-${role.id}`" @click.prevent></label>
          </td>
          <td :data-label="$t('components.rolePicker.table.headers.name')">
            {{ role.name }}
          </td>
          <td v-if="publicOnly" :data-label="$t('components.rolePicker.table.headers.description')">
            {{ role.description }}
          </td>
        </tr>
      </BaseTable>

      <template #footer>
        <a href="#" class="btn btn-feat btn-mobile-full" @click.prevent="closeModal">
          <span class="glyphicon glyphicon-check" aria-hidden="true"></span>
          {{ $t('common.done') }}
        </a>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseListItemPicker from './base/BaseListItemPicker';
import BaseModal from './base/BaseModal';
import roleService from '../services/role.service';
import BaseTable from './base/BaseTable';

export default {
  name: 'RolePicker',

  components: { BaseTable, BaseModal, BaseListItemPicker },

  props: {
    value: {
      type: Array,
      required: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    publicOnly: {
      type: Boolean,
      default: false,
    },
    modalOnly: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      loading: false,
      modal: false,
      roles: [],
      params: {},
      pagination: {},
    };
  },

  computed: {
    selectedRoleSet() {
      return new Set(this.value.map((r) => r.code));
    },
  },

  created() {
    this.getRoles();
  },

  methods: {
    closeModal() {
      this.modal = false;
      this.$emit('close');
    },

    getRoles(page = 1) {
      const params = { ...this.params, page };
      this.loading = true;
      const getRoles = this.publicOnly ? roleService.getPublicList : roleService.getList;
      getRoles(params)
        .then((res) => {
          this.roles = res.data.role;
          this.pagination = {
            page: res.data.page,
            total: res.data.total,
            pageSize: res.data.pageSize,
          };
        })
        .catch(() => {
          this.roles = [];
          this.pagination = {};
        })
        .finally(() => {
          this.loading = false;
        });
    },

    toggleRole(role) {
      const newValue = this.selectedRoleSet.has(role.code)
        ? this.value.filter((r) => r.code !== role.code)
        : [...this.value, role];
      this.$emit('input', newValue);
    },
  },
};
</script>
